export const INT_32_MIN = -2_147_483_648; // smallest value of 32-bit signed integer
export const INT_32_MAX = 2_147_483_647; // largest value of 32-bit signed integer
